//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.NCGroupBuilder.js";
import "../CAM/CAM.InheritableColorPickerBuilder.js";
import "../CAM/CAM.CutterExport.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.Ude.js";
import "../CAM/CAM.ManageToolPartBuilder.js";
import "../CAM/CAM.InheritableIntBuilder.js";
let d=[[[0,"ChannelName",1,0],[1,"ColorPickerBuilder",0,"CAM.InheritableColorPickerBuilder",0],[1,"CutterExportBuilder",0,"CAM.CutterExport",0],[0,"HolderDescription",1,0],[0,"HolderLibraryReference",1,0],[1,"IncrementalTurretRotationBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"IndexNotchBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"LibraryParametersBuilder",0,"CAM.Ude",0],[1,"ManageToolPart",0,"CAM.ManageToolPartBuilder",0],[0,"TlCtlgNum",1,0],[0,"TlDescription",1,0],[1,"TlHolderNumberBuilder",0,"CAM.InheritableIntBuilder",0],[0,"TlLibref",1,0],[0,"TlManualToolChange",1,0],[1,"TlNumberBuilder",0,"CAM.InheritableIntBuilder",0],[0,"TlText",1,0],[0,"ToolAssemblyPartName",1,0]],[[[],"GetMaterial",{R_:{libRef:''}},0,0],[["libRef"],"SetMaterial",{},1,0],[["libRef","name","description","code"],"GetMaterialData",{},0,0]],[]];
SPLM.CAM.ToolBuilder = class extends SPLM.CAM.NCGroupBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;